import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {User} from "../domain/user";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload/ng2-file-upload";
import {KmHistoryService} from "../service/kmHistory.service";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";
import {DATE_VALID_CHARACTERS, DATE_VALIDATOR, DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE, KmFormat} from "../validators/validators";
import {KmHistory} from "../domain/kmHistory";

@Component({
    selector: 'kmHistory-panel',
    template: require('./kmHistory.panel.component.html'),
    styles: [require('./kmHistory.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe, KmFormat],
})
export class KmHistoryPanelComponent implements OnInit, AfterViewInit {

    public errorMessages: any;

    private data: Vehicle[];

    private banks: Bank[];

    public bankTodos: Bank;

    private filter: Vehicle;

    public loadDateSince: string;
    public loadDateUntil: string;

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    private userLogged: User;

    public canEditKmHistory: boolean;
    public canViewKmHistory: boolean;

    public showFilters: boolean;

    public oneClickBulkLoad: boolean;

    @ViewChild('bulkLoadKmHistory') bulkLoad: ElementRef;
    @ViewChild('bulkLoadKmHistoryModal') bulkLoadModal: ModalDirective;
    errorsBulkLoad: string[];

    public uploaderBulkLoad: FileUploader;
    public hasBulkLoadDropZoneOver: boolean;

    constructor(private router: Router,
                private kmHistoryService: KmHistoryService,
                private bankService: BankService,
                private loginService: LoginService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {
        this.data = [];

        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.banks = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.canEditKmHistory = false;
        this.canViewKmHistory = false;

        this.showFilters = false;

        this.errorsBulkLoad = [];

        this.createUploaderBulkLoad();

        this.filter = new Vehicle();
        this.form = new FormGroup({
            patent: new FormControl(),
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),

            loadDateSince: new FormControl(this.loadDateSince, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateLoadDateSinceRequired.bind(this)]),
            loadDateUntil: new FormControl(this.loadDateUntil, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateLoadDateUntilRequired.bind(this)]),

            itemsPerPage: new FormControl()
        });

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

        this.filter.kmHistories = [];
        this.filter.kmHistories[0] = new KmHistory(null);

        this.oneClickBulkLoad = false;
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
            || (this.filter.contract.bank && this.filter.contract.bank.id != '')
            || (this.loadDateSince && this.loadDateUntil));
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            if (this.loadDateSince && this.loadDateUntil) {
                if (this.filter.kmHistories.length == 0) {
                    this.filter.kmHistories = [];
                    this.filter.kmHistories[0] = new KmHistory(null);
                }
                this.filter.kmHistories[0].loadDateSince = this.loadDateSince;
                this.filter.kmHistories[0].loadDateUntil = this.loadDateUntil;
            }


            this.kmHistoryService.findKmHistory(this.filter, page, this.itemsPerPage).subscribe(
                (data) => {
                    this.refreshData(data);
                    this.page = page;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar los vehículos.');
                });
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public editItem(item: Vehicle): void {
        this.router.navigate(['app/home/editKmHistory', item.id]);
    }

    public downloadFilterKmHistories(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';

            if (this.loadDateSince && this.loadDateUntil) {
                if (this.filter.kmHistories.length == 0) {
                    this.filter.kmHistories = [];
                    this.filter.kmHistories[0] = new KmHistory(null);
                }
                this.filter.kmHistories[0].loadDateSince = this.loadDateSince;
                this.filter.kmHistories[0].loadDateUntil = this.loadDateUntil;
            }

            /*
             * Se exportan todos los históricos de vehículos que cumplan con el filtro.
             * Sólo los históricos de vehículos de la página actual se descargan.
             */
            window.location.href = window.location.origin +
                KmHistoryService.getURLFilterKmHistories(this.filter, this.page, this.itemsPerPage);

            this.loading = false;
        }
    }

    public close(saved: Vehicle): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.canEditKmHistory = this.userLogged.isActionAllowed('KM_HISTORY', 'EDIT', 'KM_HISTORY');
        this.canViewKmHistory = this.userLogged.isActionAllowed('KM_HISTORY', 'VIEW', 'KM_HISTORY');

        if (this.userLogged.rol.client) {
            if (this.userLogged.cuit) {
                this.filter.contract.cuit = this.userLogged.username;
            } else {
                this.filter.patent = this.userLogged.username;
            }
            this.filter.contract.bank.id = this.userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
        this.getPage(1);
    }

    public createUploaderBulkLoad(): void {
        this.uploaderBulkLoad = new FileUploader({
            url: 'kmHistory/bulkLoad',
            maxFileSize: FILE_MAX_SIZE,
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']*/
        });
        this.hasBulkLoadDropZoneOver = false;

        this.uploaderBulkLoad.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        KmHistoryService.getURLKmHistoryBulkload(message[1]);
                }
            } else if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de histórico de vehículos no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        KmHistoryService.getURLKmHistoryBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de histórico de vehículos cancelada.");
                }
            }
            this.showBulkLoadModal();
            this.oneClickBulkLoad = false;
        };
    }

    public fileOverBulkLoad(e: any): void {
        this.hasBulkLoadDropZoneOver = e;
    }

    public ngAfterViewInit() {
        /*Limpieza de inputs al agregar a la cola el archivo*/
        this.uploaderBulkLoad.onAfterAddingFile = (
            item => {
                this.bulkLoad.nativeElement.value = '';
                this.reportMessage = null;
            });
    }

    public showBulkLoadModal(): void {
        this.bulkLoadModal.show();
        this.disableLoading();
    }

    public hideBulkLoadModal(): void {
        this.bulkLoadModal.hide();
        this.errorsBulkLoad = [];
    }

    public disableLoading(): void {
        this.loading = false;
        this.oneClickBulkLoad = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    public enableOneClickBulkload(): void {
        this.oneClickBulkLoad = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    private validateLoadDateSinceRequired(group: FormControl): any {
        if (!this.loadDateSince && this.loadDateUntil) {
            this.form.controls['loadDateUntil'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    private validateLoadDateUntilRequired(group: FormControl): any {
        if (this.loadDateSince && !this.loadDateUntil) {
            this.form.controls['loadDateSince'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    public triggerLoadDateValidators(): void {
        this.form.controls['loadDateSince'].updateValueAndValidity();
        this.form.controls['loadDateUntil'].updateValueAndValidity();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/kmHistory/kmHistory.panel.component.ts
 **/